import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["popover", "messageText"]

  toggle() {
    this.popoverTarget.classList.toggle("hidden")
  }

  close() {
    this.popoverTarget.classList.add("hidden")
  }

  send(event) {
    event.preventDefault()
    const form = this.popoverTarget.querySelector("form")
    if (form) form.submit()
  }
}
